import './styles.scss';

import { Import, ImportWithAirport } from '@/models/gen/graphql';
import { ReactElement, memo, useMemo } from 'react';
import { getClasses, getProperty } from '@/utils';

import ManifestTableHeader from './ManifestTableHeader';
import ManifestTableRow from './ManifestTableRow';
import Table from '@/common/Table';
import { useManifestsState } from '@/features/Manifests';

const ManifestTable = (): ReactElement => {
  const [{ imports, sortBy, sortDirection }] = useManifestsState(({ state }) => [
    {
      imports: state.imports,
      sortBy: state.table.sorting.column,
      sortDirection: state.table.sorting.direction,
    },
  ]);

  const sortedRows = useMemo((): Import[] => {
    return [...imports].sort((a: ImportWithAirport, b: ImportWithAirport): number => {
      if (!sortBy || !sortDirection) return 0;
      const aValue = (getProperty(sortBy, a) as string) ?? '';
      const bValue = (getProperty(sortBy, b) as string) ?? '';
      const aLower = typeof aValue === 'string' ? aValue.toLowerCase() : aValue;
      const bLower = typeof bValue === 'string' ? bValue.toLowerCase() : bValue;
      if (aLower < bLower) return sortDirection === 'asc' ? -1 : 1;
      if (aLower > bLower) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    }) as unknown as Import[];
  }, [imports, sortBy, sortDirection]);

  return (
    <Table className={getClasses('ManifestTable')} header={<ManifestTableHeader />} onEnd={console.log} showControls>
      {!sortedRows.length && (
        <Table.Row style={{ gridTemplateColumns: '1fr' }}>
          <Table.Cell className="text-center">
            <i className="fa fa-inbox" /> <span>No Records</span>
          </Table.Cell>
        </Table.Row>
      )}
      {sortedRows.map(
        (importWithAirport: Import): ReactElement => (
          <ManifestTableRow key={importWithAirport.id} {...importWithAirport} />
        )
      )}
    </Table>
  );
};

export default memo(ManifestTable);
